import { WAYPOINT_ICONS } from '../constants';

export const getWaypointIcon = (name: string): string => WAYPOINT_ICONS[name] || '';
